import React from "react";
import "./Footer.css";
import {
  FaAngleDoubleRight,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaTiktok,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      {/* Gradient CTA Section */}
      <div className="footer__cta">
        <div className="footer__cta-container">
          <div className="footer__cta-content">
            <h2 className="footer__cta-title">
              Ready to Reclaim Your Space?{" "}
              <span className="footer__cta-highlight">Let's Talk</span>
            </h2>
            <p className="footer__cta-subtitle">
              Claim your complimentary assessment and estimate now.
            </p>
          </div>

          {/* External booking link (opens in new tab) */}
          <a
            href="https://app.squareup.com/appointments/book/41vplmwf0luh01/LTHMTFD90TMRT/start"
            className="footer__cta-button"
            aria-label="Book your complimentary assessment"
            target="_blank"
            rel="noopener noreferrer"
          >
            Book Now <FaAngleDoubleRight className="footer__cta-icon" />
          </a>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="footer__main">
        <div className="footer__main-container">
          {/* Company Info */}
          <div className="footer__company">
            <Link to="/" className="footer__logo-link" aria-label="Go to home">
              <img
                src="/logoo.png"
                alt="Greenworks Logo"
                className="footer__logo-img"
                height={50}
                width={160}
              />
            </Link>

            <p className="footer__company-description">
              Premium junk removal services with eco-friendly solutions for
              residential and commercial properties.
            </p>

            <div className="footer__social" aria-label="Social links">
              <a
                href="https://www.facebook.com/share/168QuzNNwW/?mibextid=wwXIfr"
                className="footer__social-link"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.tiktok.com/@tacomasjunkremoval?_t=ZP-8yzbqSe1a8d&_r=1"
                className="footer__social-link"
                aria-label="TikTok"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTiktok />
              </a>
              <a
                href="http://instagram.com/tacomasjunkremoval/"
                className="footer__social-link"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* Navigation Sections */}
          <div className="footer__sections-grid">
            {/* Quick Links */}
            <nav className="footer__section" aria-label="Quick Links">
              <h3 className="footer__section-title">Quick Links</h3>
              <ul className="footer__section-list">
                <li className="footer__section-item">
                  <Link to="/" className="footer__section-link">Home</Link>
                </li>
                <li className="footer__section-item">
                  <Link to="/about" className="footer__section-link">About</Link>
                </li>
                <li className="footer__section-item">
                  <Link to="/contact" className="footer__section-link">Contact</Link>
                </li>
              </ul>
            </nav>

            {/* Services */}
            <nav className="footer__section" aria-label="Services">
              <h3 className="footer__section-title">Services</h3>
              <ul className="footer__section-list">
                <li className="footer__section-item">
                  <Link to="/services/household-junk" className="footer__section-link">
                    Household Junk Removal
                  </Link>
                </li>
                <li className="footer__section-item">
                  <Link to="/services/garage-cleanouts" className="footer__section-link">
                    Garage Cleanouts
                  </Link>
                </li>
                <li className="footer__section-item">
                  <Link to="/services/construction-debris" className="footer__section-link">
                    Construction Debris
                  </Link>
                </li>

                {/* ✅ Added new services */}
                <li className="footer__section-item">
                  <Link to="/services/YardDebrisRemoval" className="footer__section-link">
                    Yard Debris Removal
                  </Link>
                </li>
                <li className="footer__section-item">
                  <Link to="/services/Foreclosures&Evictions" className="footer__section-link">
                    Foreclosures &amp; Evictions
                  </Link>
                </li>
                <li className="footer__section-item">
                  <Link to="/services/Donationpickups" className="footer__section-link">
                    Donation Pickups
                  </Link>
                </li>
                <li className="footer__section-item">
                  <Link to="/services/Junkremoval" className="footer__section-link">
                    Junk Removal
                  </Link>
                </li>
              </ul>
            </nav>

            {/* Contact */}
            <section className="footer__section" aria-label="Contact">
              <h3 className="footer__section-title">Contact Us</h3>
              <ul className="footer__section-list">
                <li className="footer__contact-item">
                  <FaMapMarkerAlt className="footer__contact-icon" />
                  <span className="footer__contact-text">Tacoma, WA</span>
                </li>
                <li className="footer__contact-item">
                  <FaPhoneAlt className="footer__contact-icon" />
                  <a href="tel:2532205010" className="footer__contact-link">
                    253-220-5010
                  </a>
                </li>
                <li className="footer__contact-item">
                  <FaEnvelope className="footer__contact-icon" />
                  <a
                    href="mailto:info@tacomasjunkremoval.com"
                    className="footer__contact-link"
                  >
                    info@tacomasjunkremoval.com
                  </a>
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer__bottom">
        <div className="footer__bottom-container">
          <p className="footer__copyright">
            © {new Date().getFullYear()} Tacoma's Junk Removal. All rights reserved.
          </p>

          <div className="footer__legal">
            <Link to="/privacy" className="footer__legal-link">
              Privacy Policy
            </Link>
            <span className="footer__separator">|</span>
            <span className="footer__design-credit">
              <a
                href="https://connectrader.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__design-link"
              >
                Site By connectrader
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;